import React from 'react';
import FullNameField from 'platform/forms-system/src/js/fields/FullNameField';
import fullSchema from 'vets-json-schema/dist/21-526EZ-ALLCLAIMS-schema.json';
import get from 'platform/utilities/data/get';
import {
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { createAllowedCharValidator } from '../validations';

const { alternateNames: alternateNamesSchema } = fullSchema.properties;

const hasAlternateName = formData =>
  get('view:hasAlternateName', formData, true);

export const uiSchema = {
  'ui:title': <h3 className="vads-u-margin-y--0">Alternate names</h3>,
  'view:hasAlternateName': yesNoUI({
    title: 'Have you served under a different name?',
  }),
  alternateNames: {
    'ui:description': 'What name did you serve under?',
    'ui:options': {
      viewField: FullNameField,
      reviewTitle: 'Other names',
      expandUnder: 'view:hasAlternateName',
      itemName: 'Name',
    },
    items: {
      first: {
        'ui:title': 'First name',
        'ui:autocomplete': 'given-name',
        'ui:required': hasAlternateName,
        'ui:validations': [
          createAllowedCharValidator(
            alternateNamesSchema.items.properties.first.pattern,
            'first name',
          ),
        ],
      },
      middle: {
        'ui:title': 'Middle name',
        'ui:autocomplete': 'additional-name',
        'ui:validations': [
          createAllowedCharValidator(
            alternateNamesSchema.items.properties.middle.pattern,
            'middle name',
          ),
        ],
      },
      last: {
        'ui:title': 'Last name',
        'ui:autocomplete': 'family-name',
        'ui:required': hasAlternateName,
        'ui:validations': [
          createAllowedCharValidator(
            alternateNamesSchema.items.properties.last.pattern,
            'last name',
          ),
        ],
      },
    },
  },
};

export const schema = {
  type: 'object',
  properties: {
    'view:hasAlternateName': yesNoSchema,
    alternateNames: {
      type: 'array',
      minItems: 1,
      maxItems: 100,
      items: {
        type: 'object',
        properties: {
          first: {
            $ref: '#/definitions/fullName/properties/first',
          },
          middle: {
            $ref: '#/definitions/fullName/properties/middle',
          },
          last: {
            $ref: '#/definitions/fullName/properties/last',
          },
        },
      },
    },
  },
};
